const TransactionStatusTransformer = (type) => {
  if (type === 'DOMESTIC') return 'Domestic';
  if (type === 'INTRA') return 'EU';
  if (type === 'INTER') return 'International';

  return type;
}

export default TransactionStatusTransformer;
